export default {"src":"/_next/static/media/purple_filled_icon.9f52ecee.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};